import React, { useState, useEffect } from 'react';
import { eventManager } from '../util/eventManager';

export const useDocumentTitle = (title: string): void => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = title;
        return () => document.title = previousTitle;
    }, []);
};

export const PageTitleContext = React.createContext({ title: '', icon: null });
let baseTitle: string = null;
const UPDATE_PAGE_TITLE_ACTION = 'UPDATE_PAGE_TITLE';

export const usePageTitle = (pageTitle: string, icon: React.ReactNode = null) => {
    eventManager.emit(UPDATE_PAGE_TITLE_ACTION, { title: pageTitle, icon });
};

export const PageTitleProvider: React.FunctionComponent<{title?: string}> = (props) => {
    const [ pageTitle, setPageTitle ] = useState<string>(props.title || '');
    const [ pageIcon, setPageIcon ] = useState<React.ReactNode|null>(null);

    const updatePageTitle = ({ title: newTitle, icon }) => {
        if (newTitle !== pageTitle || pageIcon !== icon) {
            setPageTitle(newTitle);
            setPageIcon(icon);
            if (baseTitle === null) {
                baseTitle = document.title;
            }
            document.title = `${newTitle} - ${baseTitle}`;
        }
    };

    useEffect(() => {
        eventManager.on(UPDATE_PAGE_TITLE_ACTION, updatePageTitle);
        return () => eventManager.off(UPDATE_PAGE_TITLE_ACTION, updatePageTitle);
    }, []);

    return (
        <PageTitleContext.Provider value={{ title: pageTitle, icon: pageIcon }}>{props.children}</PageTitleContext.Provider>
    );
};
